/** 是否為開發模式 */
export const isDev = process.env.NODE_ENV === 'development'

/** 語系路由正則 */
export const LocaleRegex = /\/(en|vi|zh|th|id|ko|ms|ja)(?=\/|$)/

/** 所有商戶 key 比對用，請填 REACT_APP_PLATFORM 中的值  */
export enum PLATFORMS {
  // 正式商户
  WOWGAMES = 'wowgames_agent',
  OKBET = 'okbet_agent',
  EPLAY = 'eplay_agent',
  OKFUN = 'okfun_agent',
}

/** 商戶環境變數 */
export const Platform = Object.freeze({
  // 版本號
  GIT_HASH: String(process.env.REACT_APP_GIT_HASH || ''),
  // TAG 版本號
  GIT_TAG: String(process.env.REACT_APP_GIT_TAG || ''),
  // 專案名
  PROJECT: String(process.env.REACT_APP_PROJECT),
  // 商戶 Key
  PLATFORM: String(process.env.REACT_APP_PLATFORM),
  // Build 時間戳
  BUILD_TIME: Number(process.env.REACT_APP_BUILD_TIME || 0),
  // 語系列表
  LOCALES: String(process.env.REACT_APP_LOCALES).split(','),
  // 預設語系
  LOCALE: String(process.env.REACT_APP_LOCALE) as LocaleKeys,
  // 預設 Theme
  THEME: String(process.env.REACT_APP_THEME) as ThemeMode,
  // 測試或正式域名
  SITE_URL: String(process.env.REACT_APP_SITE_URL),
  // 網址
  API_URL: String(process.env.REACT_APP_API_URL || '').replace(/\/+$/, ''),
  // Base Path
  BASE_PATH: String(process.env.REACT_APP_BASE_PATH || ''),
  // 畫面比例模式
  VIEW_MODE: String(process.env.REACT_APP_VIEW_MODE || ''),
  // 是否啟用 PWA
  PWA: String(process.env.REACT_APP_PWA || '') !== 'false',
})

/** 可以帶到網址上的參數，註冊位置 */
export enum WEB_SEARCH_QUERY {
  // 安全範圍
  SAFE_AREA = 'safeArea',
  // 登入鑒權
  TOKEN = 'token',
  // 語系
  LANG = 'lang',
  // 簡易版型：給純頁面使用，去頭去尾，不初始化用戶等其他初始行為
  SIMPLE_PAGE = 'simple',
}

/** 共用彈窗名稱在此定義 */
export enum MODAL_NAME {
  // 圖片上傳前的編輯視窗
  EDIT_IMAGE_FILE = 'EDIT_IMAGE_FILE',
}
